import {inject, Injectable} from '@angular/core';
import {CanActivateFn, GuardResult, RedirectCommand, Router} from '@angular/router';
import {AuthService} from "../../core/service/auth.service";
import {filter, Observable, of, switchMap} from "rxjs";
import {take} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AdminApprovalGuard  {
  constructor(private router: Router,
              private authService: AuthService) {}

  canActivate(): Observable<GuardResult> {
    return this.authService.getUserId().pipe(
      filter(Boolean),
      take(1),
      switchMap(() => this.authService.isAdminApproval().pipe(
        switchMap(hasRole => {
          if (!hasRole) {
            return of(new RedirectCommand(this.router.parseUrl('/admin'), {replaceUrl: true}));
          } else {
            return of(hasRole);
          }
        })
      ))
    );
  }
}

export const adminApprovalGuardFn: CanActivateFn = (route, state) => {
  return inject(AdminApprovalGuard).canActivate();
}
